const router = {
  name: "goods",
  path: "/",
  component: () => import("@/views/goods/goods.vue"),
  meta: { 
    translate: "goods",
    title: "goods",
    icon: "el-icon-s-shop"
  }
};

export default router;
